<form *ngIf="form" [formGroup]="form">
  <app-product-lookup
    [label]="'entity.material' | translate | ucfirst"
    formControlName="productId"
    (valueChanged)="onProductChanged()"
    ></app-product-lookup>
    <dx-text-box   (mouseenter)="visibleQTooltip = true"
                   (mouseleave)="visibleQTooltip = false"
                   id="formulaDescription"
                   [label]="'common.quantity' | translate | ucfirst" formControlName="quantity" formField required></dx-text-box>
  <dx-tooltip
    [(visible)]="visibleQTooltip"
    target="#formulaDescription"
  >
    {{ 'entity.processSheet.formulaDescription' | translate | ucfirst  }}
  </dx-tooltip>
  <dx-lookup formField required formControlName="productFormatId"
             [label]="'entity.product.formatCode' | translate | ucfirst"
             [dataSource]="formats"
             [placeholder]="'entity.product.formatCode' | translate | ucfirst"
             displayExpr="formatName"
             valueExpr="id"
  />
  <dx-text-box
    id="formulaDescriptionWithMaterialQty"
    (mouseenter)="visibleWasteTooltip = true"
    (mouseleave)="visibleWasteTooltip = false"
    [title]="'entity.processSheet.formulaDescriptionWithMaterialQty'"
    [label]="'entity.processSheet.waste' | translate | ucfirst"
    formControlName="waste"
    formField
    required>
  </dx-text-box>
  <dx-tooltip
    [(visible)]="visibleWasteTooltip"
    target="#formulaDescriptionWithMaterialQty"
  >
    <div *dxTemplate="let d of 'content'">
      <div style="white-space: pre-line; text-align: left;">
        {{ 'entity.processSheet.formulaDescriptionWithMaterialQty' | translate }}
      </div>
    </div>
  </dx-tooltip>

</form>
